<div class="monitors-divider-select" [clickOutside]="[]" [parentComponent]="parentContainer">
  <div class="monitor-blue" (click)="toggleSelection()" data-testingId="modes-selector"
    [style.border-bottom]="rss?.Url || rss?.FileId ? '5px solid' : 'none'"
    [style.border-bottom-color]="rss?.Url || rss?.FileId ? rss.BackgroundColor : 'transparent'"
    [ngClass]="{
      'portrait-view': selectedMode.includes(appConst.PORTRAIT_VIEW),
      'flex-column': selectedMode.includes(appConst.COLUMN_VIEW)
    }">
      <ng-container *ngFor="let modeValue of modes[selectedMode] | numberToArray; let i = index">
        <ng-container [ngTemplateOutlet]="mclMonitors" [ngTemplateOutletContext]="{ $implicit: selectedMode, index: i }">
        </ng-container>
      </ng-container>
  </div>

  <mat-icon svgIcon="border_color" class="settings-icon" (click)="onConfigureBorders()"
    matTooltip="Configure Borders"></mat-icon>

  <div class="sections-overlay" data-testingId="sections-overlay" *ngIf="showMawChromeOptions">
    <div class="sections-container">
      <ng-container *ngFor="let mode of modes | keyvalue: originalOrder">
        <div class="wrapper" [class.centered]="mode.key.includes(appConst.CENTERED)">
          <div class="options-monitors" data-testingId="mcl-modes"
            [ngClass]="{
              'selected': selectedMode == mode.key,
              'portrait-view': mode.key.includes(appConst.PORTRAIT_VIEW),
              'flex-column': mode.key.includes(appConst.COLUMN_VIEW)}"
            (click)="onChangeMode(mode)">
            <ng-container *ngFor="let modeValue of mode.value | numberToArray; let i = index">
              <ng-container [ngTemplateOutlet]="mclMonitors" [ngTemplateOutletContext]="{ $implicit: mode.key, index: i, isOptions: true }">
              </ng-container>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #mclMonitors let-mode let-idx="index" let-isOptions="isOptions">
  <div class="monitor-blocks"
    [ngClass]="{
      'options': isOptions,
      'four-monitors': mode === appConst.FOUR_MONITORS_OPTION,
      'five-monitors': mode === appConst.FIVE_MONITORS_1_ROW_REST_COLUMN_OPTION,
      'five-monitors-reversed': mode === appConst.FIVE_MONITORS_5_COLUMN_OPTION,
      'six-monitors': mode === appConst.SIX_MONITORS_OPTION,
      'nine-monitors': mode === appConst.NINE_MONITORS_OPTION,
      'two-monitors-unequal': mode === appConst.TWO_MONITORS_ROW_UNEQUAL_OPTION,
      'two-monitors-unequal-reversed': mode === appConst.TWO_MONITORS_ROW_UNEQUAL_REVERSED_OPTION,
      'three-monitors-1-row-2-column': mode === appConst.TREE_MONITORS_1_ROW_2_3_COLUMN_OPTION,
      'three-monitors-2-column-3-row': mode === appConst.TREE_MONITORS_1_2_COLUMN_3_ROW_OPTION,
      'five-monitors-2-column-1-row-2-column': mode === appConst.FIVE_MONITORS_1_2_COLUMN_3_ROW_4_5_COLUMN_OPTION
    }">{{ idx + 1 }}</div>
</ng-template>
